/**
 * @generated SignedSource<<4a7923339b2cbd295e10fba4f6eedc61>>
 * @relayHash ea99db2d334a94ff820ac76b168b5dab
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fc11949bfb68d24a654ecbae157be43e2f2bd5f7436c25df55f43e630df3526f

import type { ConcreteRequest } from 'relay-runtime';
export type LicenseStatus = "ACTIVE" | "SUSPENDED" | "UNLICENSED" | "%future added value";
export type useTemplatesCollectionEligibleQuery$variables = Record<PropertyKey, never>;
export type useTemplatesCollectionEligibleQuery$data = {
  readonly confluence_tenantContext: {
    readonly licensedProducts: ReadonlyArray<{
      readonly licenseStatus: LicenseStatus;
      readonly productKey: string;
    }>;
  } | null | undefined;
  readonly user: {
    readonly confluence: {
      readonly hasPersonalSpace: boolean | null | undefined;
      readonly space: {
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
    readonly team: string | null | undefined;
  } | null | undefined;
};
export type useTemplatesCollectionEligibleQuery = {
  response: useTemplatesCollectionEligibleQuery$data;
  variables: useTemplatesCollectionEligibleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = [
  {
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "LicensedProduct",
        "kind": "LinkedField",
        "name": "licensedProducts",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "licenseStatus"
          },
          {
            "kind": "ScalarField",
            "name": "productKey"
          }
        ]
      }
    ]
  },
  {
    "alias": "user",
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      {
        "kind": "ScalarField",
        "name": "team"
      },
      {
        "concreteType": "ConfluenceUser",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "hasPersonalSpace"
          },
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useTemplatesCollectionEligibleQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useTemplatesCollectionEligibleQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ea99db2d334a94ff820ac76b168b5dab",
    "id": "fc11949bfb68d24a654ecbae157be43e2f2bd5f7436c25df55f43e630df3526f",
    "metadata": {},
    "name": "useTemplatesCollectionEligibleQuery",
    "operationKind": "query",
    "text": "query useTemplatesCollectionEligibleQuery{confluence_tenantContext{licensedProducts{licenseStatus,productKey}},user:confluence_atlassianUser{id,team,confluence{hasPersonalSpace,space{id,key}}}}"
  }
};
})();

(node as any).hash = "4c6390ae7a1c60c33ec38b4eadda65e8";

export default node;
